import React from "react";

const IconColorAllegens = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 27 27">
      <g
        id="Group_1462"
        dataname="Group 1462"
        transform="translate(-1111 -435)"
      >
        <circle
          id="Ellipse_226"
          dataname="Ellipse 226"
          cx="13.5"
          cy="13.5"
          r="13.5"
          transform="translate(1111 435)"
          fill="#ffccd3"
        />
        <g
          id="Group_1459"
          dataname="Group 1459"
          transform="translate(812.158 -17.905)"
        >
          <circle
            id="Ellipse_226-2"
            dataname="Ellipse 226"
            cx="8.35"
            cy="8.35"
            r="8.35"
            transform="translate(303.992 458.205)"
            fill="none"
            stroke="#c40920"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.5"
          />
          <g
            id="Group_1458"
            dataname="Group 1458"
            transform="translate(308.812 462.104)"
          >
            <path
              id="Path_3779"
              dataname="Path 3779"
              d="M340.6,490.673h-5.844v.19l-.6,6.588a.763.763,0,0,0,.691.83c.023,0,.046,0,.069,0h5.533a.763.763,0,0,0,.763-.764c0-.023,0-.046,0-.069l-.6-6.588v-.19h-5.843"
              transform="translate(-334.15 -489.383)"
              fill="none"
              stroke="#c40920"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.5"
            />
            <path
              id="Path_3780"
              dataname="Path 3780"
              d="M337.954,483.933a1.789,1.789,0,0,0,.346-1.332h2.579"
              transform="translate(-337.346 -482.601)"
              fill="none"
              stroke="#c40920"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.5"
            />
            <path
              id="Path_3781"
              dataname="Path 3781"
              d="M359.174,483.933a1.789,1.789,0,0,1-.346-1.332H356.25"
              transform="translate(-352.718 -482.601)"
              fill="none"
              stroke="#c40920"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.5"
            />
            <line
              id="Line_116"
              dataname="Line 116"
              x2="5.157"
              transform="translate(0.954 0.666)"
              fill="none"
              stroke="#c40920"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.5"
            />
            <circle
              id="Ellipse_227"
              dataname="Ellipse 227"
              cx="1.332"
              cy="1.332"
              r="1.332"
              transform="translate(2.13 3.119)"
              fill="none"
              stroke="#c40920"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.5"
            />
          </g>
          <line
            id="Line_117"
            dataname="Line 117"
            x1="1.558"
            y2="1.558"
            transform="translate(306.494 470.844)"
            fill="none"
            stroke="#c40920"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.5"
          />
          <line
            id="Line_117-2"
            dataname="Line 117"
            x1="7.818"
            y2="7.818"
            transform="translate(308.052 463.025)"
            fill="none"
            stroke="#c40920"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.5"
          />
          <line
            id="Line_117-3"
            dataname="Line 117"
            x1="2.317"
            y2="2.317"
            transform="translate(315.871 460.708)"
            fill="none"
            stroke="#c40920"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.5"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconColorAllegens;
